export enum ELECTRON_MEET_WINDOW_EVENTS {
    CALL_STARTED = 'CALL_STARTED',
    CALL_ACCEPTED = 'CALL_ACCEPTED',
    CALL_REJECTED = 'CALL_REJECTED',
    CALL_DATA_CHANGE = 'CALL_DATA_CHANGE',
    WINDOW_DATA_CHANGE = 'WINDOW_DATA_CHANGE',
    TOGGLE_MUTE = 'TOGGLE_MUTE',
    READY_RECEIVE_DATA = 'READY_RECEIVE_DATA',
    NAVIGATED_PREVIEW = 'NAVIGATED_PREVIEW',
    PREVIEW_COMPLETE = 'PREVIEW_COMPLETE',
    CALL_COMPLETED = 'CALL_COMPLETED',
    SHOW_PREVIEW_SET = 'SHOW_PREVIEW_SET',
    ROOM_PARTICIPANTS_COUNT = 'ROOM_PARTICIPANTS_COUNT',
    ROOM_RECORDING_ON = 'ROOM_RECORDING_ON',
    USER_KICKED = 'USER_KICKED',
    MIC_ALWAYS_ON_BY_DEFAULT = 'MIC_ALWAYS_ON_BY_DEFAULT',
    CAMERA_ALWAYS_ON_BY_DEFAULT = 'CAMERA_ALWAYS_ON_BY_DEFAULT',
    ACCESS_REQUESTS_SOUND_SAVE = 'ACCESS_REQUESTS_SOUND_SAVE',
    ACCESS_REQUESTS_SOUND_SAVE_RESULT = 'ACCESS_REQUESTS_SOUND_SAVE_RESULT',
    ACCESS_REQUESTS_NOTIFICATIONS_SAVE = 'ACCESS_REQUESTS_NOTIFICATIONS_SAVE',
    ACCESS_REQUESTS_NOTIFICATIONS_SAVE_RESULT = 'ACCESS_REQUESTS_NOTIFICATIONS_SAVE_RESULT',
}
